import { createAction } from 'redux-actions'
import { types } from 'features/popup/store/types'

export const openPopup = createAction(types.OPEN_POPUP)
export const closePopup = createAction(types.CLOSE_POPUP)



// WEBPACK FOOTER //
// ./src/features/popup/store/actions.js